'use client';

import { useApi } from '@prismo-io/core';
import useSWRMutation from 'swr/mutation';
import { kickExperience } from '../utils/kick-experience';
export const useKickExperience = () => {
  const {
    client
  } = useApi();
  return useSWRMutation(['kick-experience'], () => kickExperience(client));
};